<template>
    <graph ref="chart" :chart-data="chart_data" :legend-position="legendPosition" />
</template>

<script type="text/javascript">
import graph_component from "./GraphComponent"

import Graph from "./TopClientsGraph.js"

export default {
    mixins: [graph_component],
    components: {
        Graph
    },
    methods: {},
    computed: {
        chart_data () {
            const chart_data = {
                labels: [],
                datasets: [
                    { backgroundColor: [], data: [], _total: 0 }
                ],
                dataset_id: this.datasetId
            }

            const go_back = parseInt(this.filter) || 0
            const firms = (this.datasetId === "fee") ? this.rawData[go_back][1] : this.rawData[go_back][0]
            firms.forEach(firm => {
                if(!firm.name.match(/^others$/i)) {
                    chart_data.labels.push(firm.name)
                    if(!!this.utilityData && !!this.utilityData[firm.name]) {
                        chart_data.datasets[0].backgroundColor.push(this.utilityData[firm.name].background)
                    }
                    chart_data.datasets[0].data.push(firm.count)
                    chart_data.datasets[0]._total += firm.count
                }
            })

            return chart_data
        }
    }
}
</script>
